const Theme = {
    code: 'bg-dark text-light font-monospace p-1',
    heading: {
        h1: 'fs-3 fw-normal mb-3 text-white',
        h2: 'fs-6 text-light fw-bold mt-3 text-uppercase',
        h3: 'fs-4 text-white',
        h4: 'fs-5 text-white',
        h5: 'fs-6 text-white',
    },
    image: 'img-fluid',
    link: 'text-info text-decoration-none',
    list: {
        ul: 'list-group text-white pl-3',
        ulDepth: [],
        ol: 'list-group text-white pl-3',
        olDepth: [],
        listitem: 'ms-4 my-1 text-white',
        listitemChecked: 'text-success',
        listitemUnchecked: 'text-danger',
        nested: {
            list: 'list-group text-white pl-1',
            listitem: 'list-unstyled',
        },
    },
    ltr: 'text-start',
    paragraph: 'mb-1 text-white',
    placeholder: 'text-muted',
    quote: 'border-start border-4 border-secondary ps-4 text-light',
    rtl: 'text-end',
    text: {
        code: 'bg-dark text-light font-monospace p-1',
        hashtag: 'text-info',
        italic: 'font-italic',
        overflowed: 'text-truncate',
        strikethrough: 'text-decoration-line-through',
        underline: 'text-decoration-underline',
        underlineStrikethrough: 'text-decoration-underline text-decoration-line-through',
    },
};

export default Theme;
